import cc from 'classcat';

import npStyles from '../styles.module.scss';

import opStyles from './styles.module.scss';

export default function OldPlatformLegalStatement({
  membershipDisclaimer,
  theme,
}) {
  return (
    <div
      className={cc([
        npStyles.legal,
        opStyles[theme],
        opStyles.oldPlatformLegal,
      ])}
      dangerouslySetInnerHTML={{ __html: membershipDisclaimer }}
    />
  );
}
